import React from 'react'
import PropTypes from 'prop-types'
export default function InputSelect(props) {
    const { id, value, optionsList = [], onChange, disabled = false, testid, classes = '', propid } = props

    return (<>
        <div className={`flex flex-row items-center border-1 border-base rounded divide-base align-middle bg-gray-5 focus:bg-white ${classes}`} >
            <select data-propid={propid} data-testid={testid} id={id} value={value} onChange={onChange} disabled={disabled} className={'form-control border-0 block appearance-none bg-white px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline'}>
                {optionsList.map(option => {
                    return (
                        <option key={option.value} value={option.value} selected={props.value}>
                            {option.label}
                        </option>
                    )
                })}
            </select>
        </div>
    </>
    )
}
InputSelect.propTypes = {
    id: PropTypes.string,
    propid: PropTypes.string,
    testid: PropTypes.string,
    value: PropTypes.string,
    optionsList: PropTypes.Arrays,
    onChange: PropTypes.any,
    disabled: PropTypes.bool,
    classes: PropTypes.string
}
